module.exports = __webpack_public_path__ + "static/media/flashtop.eb4c5837.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/Assets/Images/Worker/Detail/flashtop.png
// module id = 646
// module chunks = 7